import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CarouselService } from './carousel.service';
import { CarouselSharedComponent } from './carousel.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

import { WindowRefService } from '../../../shared/service/window/window.service';
import { BrowserService } from '../../../shared/service/browser/browser.service';

@NgModule({
    declarations: [
        CarouselSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        CarouselSharedComponent
    ],
    providers: [
        CarouselService,
        WindowRefService,
        BrowserService
    ]
})

export class CarouselSharedModule {}
